import _ from '../utils'
import PASSWORD_CONFIG from './config'

class PasswordClass {
    constructor( password ) {
        this.DOM = {
            el: password,
            input: _.select( 'input', password ),
            toggler: _.select( '.c-password__toggler', password )
        }

        this.state = true;
        this.init()
    }

    init() {
        this._listeners()
        console.log( this )
    }

    _listeners() {
        this.DOM.toggler.addEventListener( 'click', this._toggle.bind( this ) )
    }

    _toggle() {
        this.state ? this.DOM.input.type = 'text' : this.DOM.input.type = 'password'
        this.state = !this.state
    }
}

const PASSWORDS = []
PASSWORD_CONFIG.passwords.forEach( ( password ) => { PASSWORDS.push( new PasswordClass( password ) ) } )
export default PASSWORDS